import { images, brandTabs, TID } from "@/data";
import { Link } from "react-router-dom";

const Hero = () => {
  const scrollToBrands = (e) => {
    e.preventDefault();
    const el = document.querySelector("#brands");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero" id="top">
      <img className="hero__bg" src={images.heroBanner} alt="Airplane wing above the clouds at sunset" />
      <div className="hero__scrim" />

      <div className="hero__content">
        <div className="hero__left">
          <div className="hero__tabs">
            {brandTabs.map((t) => (
              <span className="hero__tab" key={t}>
                <img src={images.faviconWhite} alt="" aria-hidden="true" />
                {t}
              </span>
            ))}
          </div>
          <Link className="hero__explore" to="/brands" data-testid={TID.heroExplore}>
            Explore our brands
            <img src={images.arrowIcon} alt="" aria-hidden="true" />
          </Link>
        </div>

        <h1 className="hero__title">Turning Travel Into Happy Memories</h1>
      </div>

      <div className="hero__bottom">
        <p className="hero__tagline">
          35,000 ft up, where strategy meets wanderlust, and every journey begins with purpose.
        </p>
        <a href="#brands" className="hero__brands-link" onClick={scrollToBrands} data-testid={TID.heroBrands}>
          Our Brands
          <span className="hero__brands-arrow">↓</span>
        </a>
      </div>
    </section>
  );
};

export default Hero;
